import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconNotificationPause$1 = /*@__PURE__*/ proxyCustomElement(class WppIconNotificationPause extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-notification-pause", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.5 9C16.9853 9 19 6.98528 19 4.5C19 2.01472 16.9853 0 14.5 0C12.0147 0 10 2.01472 10 4.5C10 6.98528 12.0147 9 14.5 9ZM13 2.25C12.7239 2.25 12.5 2.47386 12.5 2.75C12.5 3.02614 12.7239 3.25 13 3.25H14.9129L12.6204 5.9246C12.4933 6.07286 12.4642 6.28153 12.5458 6.45893C12.6273 6.63633 12.8047 6.75 13 6.75H16C16.2761 6.75 16.5 6.52614 16.5 6.25C16.5 5.97386 16.2761 5.75 16 5.75H14.0871L16.3796 3.0754C16.5067 2.92714 16.5359 2.71847 16.4543 2.54107C16.3727 2.36367 16.1953 2.25 16 2.25H13Z", fill: "currentColor" }), h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.25487 1.58424C6.02085 1.96473 3.62478 4.81915 3.62478 8.07495V11.0734L2.53356 13.2691L2.52648 13.2837C2.03291 14.3333 2.79766 15.5412 3.95894 15.5412H7.37792C7.44314 16.9328 8.59225 18.0413 10 18.0413C11.4077 18.0413 12.5569 16.9328 12.6221 15.5412H16.0402C17.2009 15.5412 17.9669 14.3339 17.4731 13.2837L17.466 13.2691L16.3748 11.0734V10.2013C15.8983 10.3579 15.3955 10.4564 14.8748 10.4885V11.2495C14.8748 11.3654 14.9016 11.4796 14.9531 11.5833L16.1173 13.9257C16.14 13.9804 16.0999 14.0412 16.0402 14.0412H3.95894C3.89986 14.0412 3.85926 13.9809 3.88228 13.9257L5.0464 11.5833C5.09795 11.4796 5.12478 11.3654 5.12478 11.2495V8.07495C5.12478 5.8185 6.59696 3.85571 8.63237 3.24074C8.75812 2.65194 8.97026 2.09514 9.25487 1.58424ZM10 16.5413C9.42103 16.5413 8.94404 16.1036 8.88186 15.5412H11.1181C11.056 16.1036 10.579 16.5413 10 16.5413Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-notification-pause-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-notification-pause", "wpp-icon-notification-pause-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-notification-pause-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-notification-pause-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconNotificationPause$1);
      }
      break;
  } });
}

const WppIconNotificationPause = WppIconNotificationPause$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconNotificationPause, defineCustomElement };
